import React from "react";
import styles from './email.module.css';

export default ({ children }) => {
  return (
    <section className={styles.section}>
        <h1>Get updates on our upcoming pilgrimages!</h1>
        <form className={styles.form} name="signup" method="POST" action='/signup-thanks' data-netlify="true" data-netlify-honeypot="bot-field" >
            <input type="hidden" name="form-name" value="signup" />
            <p hidden>
            <label>
                Don’t fill this out:{" "}
                <input name="bot-field" />
            </label>
            </p>
            <p>
            <label>Email: <input className={styles.textInput} type="email" name="email" required /></label>
            </p>
            <p>
            <button type="submit">Sign up!</button>
            </p>
        </form>
    </section>
  );
};



// WEBPACK FOOTER //
// ./src/components/email.js